import API from "../api";

export const getIntegrationStatus = () =>
  API.get("/admin/integrations/status").then((r) => r.data);

export const getEmailSettings = () =>
  API.get("/admin/integrations/email").then((r) => r.data);

export const saveEmailSettings = (payload) =>
  API.put("/admin/integrations/email", payload).then((r) => r.data);

export const testEmailSettings = (recipient) =>
  API.post("/admin/integrations/email/test", null, {
    params: { recipient },
    timeout: 90000,
  }).then((r) => r.data);

export const saveWhatsAppIntegration = (payload) =>
  API.put("/admin/integrations/whatsapp", payload).then((r) => r.data);

export const getChessCoachSettings = () =>
  API.get("/admin/integrations/chess-coach").then((r) => r.data);

export const saveChessCoachSettings = (payload) =>
  API.put("/admin/integrations/chess-coach", payload).then((r) => r.data);

export const getPlayingPlatformSettings = () =>
  API.get("/admin/integrations/playing-platform").then((r) => r.data);

export const savePlayingPlatformSettings = (payload) =>
  API.put("/admin/integrations/playing-platform", payload).then((r) => r.data);
